export enum FundsActions {
    FETCH_FUNDS_DATA = 'FETCH_FUNDS_DATA',
    SORT_FUNDS_INVESTEDIN = 'SORT_FUNDS_INVESTEDIN'
}
